<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    width="650"
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
    style=" overflow: auto;padding-bottom: 53px;"
  >
    <a-form>
      <a-form-item label="拥有的栏目">
        <a-tree
          checkable
          @check="onCheck"
          :checkedKeys="checkedKeys"
          :treeData="treeData"
          @expand="onExpand"
          :selectedKeys="selectedKeys"
          :expandedKeys="expandedKeysss"
          :checkStrictly="checkStrictly"
        >
          <span slot="hasDatarule" slot-scope="{ slotTitle, ruleFlag }">
            {{ slotTitle
            }}<a-icon
              v-if="ruleFlag"
              type="align-left"
              style="margin-left:5px;color: red;"
            ></a-icon>
          </span>
        </a-tree>
      </a-form-item>
    </a-form>

    <div class="drawer-bootom-button">
      <a-dropdown
        style="float: left"
        :trigger="['click']"
        placement="topCenter"
      >
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="switchCheckStrictly(1)"
            >父子关联</a-menu-item
          >
          <a-menu-item key="2" @click="switchCheckStrictly(2)"
            >取消关联</a-menu-item
          >
          <!--<a-menu-item key="3" @click="checkALL">全部勾选</a-menu-item>
          <a-menu-item key="4" @click="cancelCheckALL">取消全选</a-menu-item>-->
          <a-menu-item key="5" @click="expandAll">展开所有</a-menu-item>
          <a-menu-item key="6" @click="closeAll">合并所有</a-menu-item>
        </a-menu>
        <a-button> 树操作 <a-icon type="up" /> </a-button>
      </a-dropdown>
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="close"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button
        @click="handleSubmit(false)"
        type="primary"
        :loading="loading"
        ghost
        style="margin-right: 0.8rem"
        >仅保存</a-button
      >
      <a-button @click="handleSubmit(true)" type="primary" :loading="loading"
        >保存并关闭</a-button
      >
    </div>
  </a-drawer>
</template>
<script>
import {
  queryTreeListForRole,
  queryRolePermission,
  saveRolePermission,
  saveRoleColumn
} from '@/api/api';
import { getAction } from '@/api/manage';
export default {
  name: 'RoleColumnModal',
  components: {},

  data() {
    return {
      roleId: '',
      treeData: [],
      defaultCheckedKeys: [],
      checkedKeys: [],
      expandedKeysss: [],
      allTreeKeys: [],
      autoExpandParent: true,
      checkStrictly: true,
      title: '角色栏目配置',
      visible: false,
      loading: false,
      selectedKeys: [],
      rootNodes: [],
      columnSets: [],
      lastColumnSets: []
    };
  },
  methods: {
    getCodeById(value) {
      console.log(value);
      for (let index in value) {
        let data = this.getSelectNodeData(this.treeData, value[index]);
        let columnSet = {};
        if (data != undefined) {
          if (data.parentId == -1) {
            columnSet.channelCode = data.code;
            columnSet.section = '';
          } else {
            columnSet.channelCode = data.channelCode;
            columnSet.section = data.code;
          }
          columnSet.columnId = data.id;
          this.columnSets.push(columnSet);
        }
      }
    },
    mergeColumnSets() {
      //去重
      let tempArray = new Array();
      for (let index in this.columnSets) {
        let item = this.columnSets[index];
        let flag = false;
        for (let ti in tempArray) {
          if (item.columnId == tempArray[ti].columnId) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          tempArray.push(item);
        }
        //复制老的设置数据
        for (let ti in tempArray) {
          let tItem = tempArray[ti];
          for (let pi in this.lastColumnSets) {
            let pItem = this.lastColumnSets[pi];
            if (tItem.columnId == pItem.columnId) {
              tempArray[ti] = pItem;
            }
          }
        }
      }
      let array = new Array();
      //根据checks去除数据
      for (let item in this.checkedKeys) {
        for (let items in tempArray) {
          if (tempArray[items].columnId == this.checkedKeys[item]) {
            array.push(tempArray[items]);
          }
        }
      }
      this.columnSets = array;
    },
    getSelectNodeData(data, key) {
      //获取选中栏目的节点数据
      for (let index in data) {
        let item = data[index];
        if (item.key == key) {
          return item;
        }
        let value = this.getSelectNodeData(item.children, key);
        if (!value) {
          continue;
        }
        return value;
      }
    },
    onCheck(o, info) {
      if (this.checkStrictly) {
        console.log(o);
        this.checkedKeys = o.checked;
        this.getCodeById(o.checked);
      } else {
        console.log(info);
        this.getCodeById(o);
        this.checkedKeys = o;
      }
      this.mergeColumnSets();
      console.log(this.columnSets);
      console.log(this.checkedKeys);
    },
    show(roleId) {
      this.roleId = roleId;
      this.visible = true;
    },
    close() {
      this.reset();
      this.$emit('close');
      this.visible = false;
    },
    onExpand(expandedKeys) {
      this.expandedKeysss = expandedKeys;
      this.autoExpandParent = false;
    },
    reset() {
      this.expandedKeysss = [];
      this.checkedKeys = [];
      this.defaultCheckedKeys = [];
      this.loading = false;
    },
    expandAll() {
      this.expandedKeysss = this.allTreeKeys;
      console.log(this.allTreeKeys);
      console.log(this.expandedKeysss);
    },
    closeAll() {
      this.expandedKeysss = [];
    },
    checkALL() {
      this.checkedKeys = this.allTreeKeys;
      console.log(this.checkedKeys);
      this.getCodeById(this.checkedKeys);
      this.mergeColumnSets();
      console.log(this.columnSets);
      console.log(this.checkedKeys);
    },
    cancelCheckALL() {
      //this.checkedKeys = this.defaultCheckedKeys
      this.checkedKeys = [];
    },
    switchCheckStrictly(v) {
      if (v == 1) {
        this.checkStrictly = false;
      } else if (v == 2) {
        this.checkStrictly = true;
      }
    },
    handleCancel() {
      this.close();
    },
    handleSubmit(exit) {
      let that = this;
      let params = {
        roleId: that.roleId,
        columnIds: that.checkedKeys.join(','),
        lastColumnIds: that.defaultCheckedKeys.join(','),
        columnSets: JSON.stringify(this.columnSets)
      };
      that.loading = true;
      console.log('请求参数：', params);
      saveRoleColumn(params).then(res => {
        if (res.success) {
          that.$message.success(res.message);
          that.loading = false;
          if (exit) {
            that.close();
          }
        } else {
          that.$message.error(res.message);
          that.loading = false;
          if (exit) {
            that.close();
          }
        }
        this.loadData();
      });
    },
    loadData() {
      let value = [];
      getAction(
        process.env.VUE_APP_CMS_CONTENT + '/content/column/list',
        {}
      ).then(res => {
        if (res.success) {
          this.treeData = res.result;
          for (let i in res.result) {
            value.push(res.result[i].id);
          }
          this.rootNodes = value;
          getAction(
            process.env.VUE_APP_CMS_CONTENT + '/content/column/listIds',
            {}
          ).then(res => {
            if (res.success) {
              this.allTreeKeys = res.result;
              getAction(
                process.env.VUE_APP_CMS_SYSTEM +
                  '/sys/roleColumnSet/queryByRoleId',
                { roleId: this.roleId }
              ).then(res => {
                this.checkedKeys = [...res.result];
                this.defaultCheckedKeys = [...res.result];
                console.log(...res.result);
                this.lastColumnSets = this.getCodeById(...res.result);
                this.expandedKeysss = this.allTreeKeys;
                console.log(this.defaultCheckedKeys);
              });
            }
          });
        }
      });
      // queryTreeListForRole().then((res) => {
      //   this.treeData = res.result.treeList
      //   this.allTreeKeys = res.result.ids
      //   queryRolePermission({roleId:this.roleId}).then((res)=>{
      //     this.checkedKeys = [...res.result];
      //     this.defaultCheckedKeys = [...res.result];
      //     this.expandedKeysss = this.allTreeKeys;
      //     console.log(this.defaultCheckedKeys)
      //   })
      // })
    }
  },
  watch: {
    visible() {
      if (this.visible) {
        this.loadData();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
